/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetUnproxiedMcpServerToolUsage } from "../funcs/telemetryGetUnproxiedMcpServerToolUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetUnproxiedMcpServerToolUsageResult } from "../models/components/getunproxiedmcpservertoolusageresult.js";
import {
  GetUnproxiedMcpServerToolUsageRequest,
  GetUnproxiedMcpServerToolUsageSecurity,
} from "../models/operations/getunproxiedmcpservertoolusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUnproxiedMcpServerToolUsageQueryData =
  GetUnproxiedMcpServerToolUsageResult;

export function prefetchGetUnproxiedMcpServerToolUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUnproxiedMcpServerToolUsageRequest,
  security?: GetUnproxiedMcpServerToolUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUnproxiedMcpServerToolUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUnproxiedMcpServerToolUsageQuery(
  client$: GramCore,
  request: GetUnproxiedMcpServerToolUsageRequest,
  security?: GetUnproxiedMcpServerToolUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUnproxiedMcpServerToolUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetUnproxiedMcpServerToolUsage({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getUnproxiedMcpServerToolUsageQueryFn(
      ctx,
    ): Promise<GetUnproxiedMcpServerToolUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetUnproxiedMcpServerToolUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUnproxiedMcpServerToolUsage(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "telemetry",
    "getUnproxiedMcpServerToolUsage",
    parameters,
  ];
}
